import { useEffect, useState } from "react";
import { api } from "../lib/api";

const LOGO_IMG = "https://customer-assets.emergentagent.com/job_chatbot-finder-pro/artifacts/c7o9vj3j_708E1372-3DBC-4AE8-BA1A-7454EC4E24EC.png";

export default function Home() {
  const [blocks, setBlocks] = useState([]);

  useEffect(() => {
    api.get("/site-blocks?page=home").then((r) => setBlocks(r.data || [])).catch(() => {});
  }, []);

  return (
    <main
      className="relative min-h-[calc(100vh-4rem)] flex items-end justify-center bg-zinc-950"
      style={{
        backgroundImage: `url(${LOGO_IMG})`,
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
      data-testid="home-hero"
    >
      <div className="absolute inset-0 bg-gradient-to-t from-zinc-950/70 via-transparent to-transparent pointer-events-none" />

      <div className="relative pb-16 px-6 text-center flex flex-col items-center gap-6">
        {blocks.map((b) => (
          b.type === "text" ? (
            <p key={b.id} data-testid={`home-block-${b.id}`} className="max-w-md text-sm text-white/90 leading-relaxed whitespace-pre-wrap">
              {b.title && <span className="block font-display font-bold text-white mb-1">{b.title}</span>}
              {b.body}
            </p>
          ) : (
            <div
              key={b.id}
              data-testid={`home-block-${b.id}`}
              className="max-w-md bg-zinc-950/55 backdrop-blur-md border border-white/15 px-6 py-4"
            >
              {b.title && <div className="font-display font-bold text-white mb-1">{b.title}</div>}
              <p className="text-sm text-white/90 leading-relaxed whitespace-pre-wrap">{b.body}</p>
            </div>
          )
        ))}
        <button
          type="button"
          onClick={() => window.dispatchEvent(new CustomEvent('open-ai-receptionist'))}
          data-testid="home-reception-link"
          className="bg-white/95 hover:bg-[#16A34A] hover:text-white text-zinc-950 px-6 py-3 font-semibold transition-colors border border-white/40 backdrop-blur inline-flex items-center gap-2"
        >
          Rosie the Receptionist — Ask Me Anything
        </button>
        <p data-testid="home-support-email" className="text-xs text-white/80 max-w-md">
          Having trouble reaching Rosie? Email us directly at{" "}
          <a href="mailto:rosie@ncrw.com.au" className="font-semibold text-white underline hover:text-[#4ADE80]">rosie@ncrw.com.au</a>
        </p>
      </div>
    </main>
  );
}
